import { ENUM__page_type } from '@/enums/ENUM__page_type';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_effect } from '@/hooks/_base/use_effect';
import { use_slice_user } from '@/hooks/store/use_slices';
import { remote_workspace_user_invitation_assign_to_user } from '@/state/workspace/user_invitation/remote_workspace_user_invitation_assign_to_user';
import { useNavigate, useParams } from 'react-router-dom';

export function PageWorkspaceInvitation() {
  const dispatch = use_dispatch();
  const navigate = useNavigate();

  const { token_user_workspace_invitation } = useParams();

  const { is_authorized } = use_slice_user(['is_authorized']);

  /*
   * EFFECT
   */

  use_effect(() => {
    if (!is_authorized) return;

    if (!token_user_workspace_invitation) return void navigate(ENUM__page_type.MAIN);

    void dispatch(remote_workspace_user_invitation_assign_to_user(token_user_workspace_invitation));

    void navigate(ENUM__page_type.MAIN);
  }, [token_user_workspace_invitation, is_authorized]);

  /*
   * HTML
   */
  return (
    <div className="flex justify-center items-center min-h-screen" id="error-page">
      <div className="flex items-center">
        <h1 className="text-2xl"></h1>
      </div>
    </div>
  );
}
